// import React, { useState } from 'react';


// const ImageCarousel = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const images = [
//     {
//       src: require("../../src/assets/images/website/doctor2.png"),
//       title: "Benefits of Patient",
//       description: "The patient portal is designed to manage primary & family members under the same account with a unique ID for each member."
//     },
//     {
//       src: require("../../src/assets/images/website/doctor5.png"),
//       title: "Benefits of Physician",
//       description: "A doctor portal is designed based on the physician's specialty and can work for any specialization."
//     },
//     {
//       src: require("../../src/assets/images/website/doctor4.png"),
//       title: "Benefits of Hospital",
//       description: "A hospital portal is designed to manage multi-specialty and different consultation modes."
//     },
//     {
//       src: require("../../src/assets/images/website/doctor6.png"),
//       title: "Benefits of Pharmacy",
//       description: "Pharmacy portals simplify medication management, allowing easy prescription refills and secure communication with pharmacists."
//     },   
//     {
//       src: require("../../src/assets/images/website/doctor3.png"),
//       title: "Benefits of Health",
//       description: "Health portals provide a comprehensive view of patient health records."
//     },
//     {
//       src: require("../../src/assets/images/website/doctor6.png"),
//       title: "Benefits of Wellness",
//       description: "Wellness portals help in tracking health and wellness activities."
//     },
    
//   ];

//   const imagesPerPage = 3; 

//   const nextImages = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + imagesPerPage) % images.length);
//   };

//   const prevImages = () => {
//     setCurrentIndex((prevIndex) => (prevIndex - imagesPerPage + images.length) % images.length);
//   };

//   return (
//     <div className='hospital-details py-5'>
//     <div className='container col-lg-11'>
//       <div className='row m-0 align-items-stretch justify-content-center'>
//         <div className='col-12'>
//           <div className='scroll-container'>
//             <div className='row m-0 align-items-stretch justify-content-start'>
//               {images.slice(currentIndex, currentIndex + imagesPerPage).map((image, index) => (
//                 <div key={index} className='col-lg-4 col-md-6 col-sm-6 col-12'>
//                   <div className='patient'>
//                     <div className='img-section'>
//                       <img src={image.src} className='w-100' alt={image.title} />
//                     </div>
//                     <div className='doctor-content'>
//                       <h1>{image.title}</h1>
//                       <div className='inner-contentss'>
//                         <div className=''>
//                           <p>{image.description}</p>
//                         </div>
//                         <div className=''>
//                           <div className='arrow-section'>
//                             <img src={require("../../src/assets/images/website/blackarrow.png")} className='icons' alt='Arrow' />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//             <div className='row m-0 justify-content-center mt-4'>
//               <div className='col-auto'>
//                 <div className='arrow-button' onClick={prevImages} style={{ backgroundColor: '#D3D3D3', padding: '10px', borderRadius: '5px' }}>
//                   <img src={require("../../src/assets/images/website/Frame1.png")} className='icons' alt='Left Arrow' />
//                 </div>
//               </div>
//               <div className='col-auto'>
//                 <div className='arrow-button' onClick={nextImages} style={{ backgroundColor: '#D3D3D3', padding: '10px', borderRadius: '5px' }}>
//                   <img src={require("../../src/assets/images/website/Frame.png")} className='icons' alt='Right Arrow' />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//     </div>
//   );
// };

// export default ImageCarousel;

// import React from 'react';

// const ImageCarousel = () => {
//   const images = [
//     {
//       src: require("../../src/assets/images/website/doctor2.png"),
//       title: "Benefits of Patient",
//       description: "The patient portal is designed to manage primary & family members under the same account with a unique ID for each member.",
//       link: "https://example.com/patient-benefits" // Add the link for the page
//     },
//     {
//       src: require("../../src/assets/images/website/doctor5.png"),
//       title: "Benefits of Doctor",
//       description: "A doctor portal is designed based on the physician's specialty and can work for any specialization.",
//       link: "https://example.com/physician-benefits" // Add the link for the page
//     },
//     {
//       src: require("../../src/assets/images/website/doctor4.png"),
//       title: "Benefits of Hospital",
//       description: "A hospital portal is designed to manage multi-specialty and different consultation modes.",
//       link: "https://example.com/hospital-benefits" // Add the link for the page
//     },
//     {
//       src: require("../../src/assets/images/website/doctor6.png"),
//       title: "Benefits of Pharmacy",
//       description: "Pharmacy portals simplify medication management, allowing easy prescription refills and secure communication with pharmacists.",
//       link: "https://example.com/pharmacy-benefits" // Add the link for the page
//     },
//     {
//       src: require("../../src/assets/images/website/doctor3.png"),
//       title: "Benefits of Health",
//       description: "Health portals provide a comprehensive view of patient health records.",
//       link: "https://example.com/health-benefits" // Add the link for the page
//     },
//     {
//       src: require("../../src/assets/images/website/doctor6.png"),
//       title: "Benefits of Wellness",
//       description: "Wellness portals help in tracking health and wellness activities.",
//       link: "https://example.com/wellness-benefits" // Add the link for the page
//     },
//   ];

//   return (
//     <div className='hospital-details3 py-5'>
//       <div className='container-75 col-lg-11'>
//         <h2 className='text-center'>Benefits</h2>
//         <p className='text-center header-description'>
//           Discover the wide-ranging benefits of using our platform. From patients to doctors, hospitals, and pharmacies, everyone stands to gain from improved efficiency, better communication, and enhanced healthcare management.
//         </p> {/* Add a description under the header */}
//         <div className='row align-items-stretch justify-content-center'>
//           {images.map((image, index) => (
//             <div key={index} className='col-lg-4 col-md-6 col-sm-6 col-12 mb-5 mt-5'>
//               <div className='patient3'>
//                 <div className='img-section3'>
//                   <img src={image.src} className='image' alt={image.title} />
//                   <div className='image-title'>
//                     <h3>{image.title}</h3>
//                   </div>
//                 </div>
//                 <div className='doctor-content3'>
//                   <h3 className='title-inside'>{image.title}</h3>
//                   <p>{image.description}</p>
//                   <a href={image.link} className='learn-more'>
//                     Learn More →
//                   </a>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ImageCarousel;

import React from 'react';

const ImageCarousel = () => {
  const images = [
    {
      src: require("../../src/assets/images/website/doctor2-300.webp"),
    srcSmall: require("../../src/assets/images/website/doctor2-150.webp"),
      title: "Benefits for Patient",
      description: "Your Time, Your Health, Your Way , Simplified & Streamlined.",
      href: "/klinicqbenifits"
    },
    {
      src: require("../../src/assets/images/website/doctor5-300.webp"),
    srcSmall: require("../../src/assets/images/website/doctor5-150.webp"),
    title: "Benefits for Doctorl",
    description: "Streamline Your Practice, Elevate Outcomes.",
    href: "/klinicqbenifits"
    },
    {
      src: require("../../src/assets/images/website/doctor4-300.webp"),
    srcSmall: require("../../src/assets/images/website/doctor4-150.webp"),
    title: "Benefits for Hospital",
    description: "Transforming Hospital Efficiency & Patient Experience.",
    href: "/klinicqbenifits"
    },
    {
      src: require("../../src/assets/images/website/229.webp"),
      title: "Benefits for Pharmacy",
      description: "Revolutionize Your Pharmacy's Efficiency & Service.",
      href: "/klinicqbenifits" 
    },
    {
      src: require("../../src/assets/images/website/244-300.webp"),
    srcSmall: require("../../src/assets/images/website/244-150.webp"),
    title: "Benefits for EMR",
    description: "- Unlock the Power of Digital Medical Records with KlinicQ",
    href: "/klinicqbenifits"
    },
    {
      src: require("../../src/assets/images/website/248-300.webp"),
    srcSmall: require("../../src/assets/images/website/248-150.webp"),
    title: "Benefits for CMS",
    description: "Revolutionizing Appointments for Safety & Convenience.",
    href: "/klinicqbenifits"
    },
  ];

  return (
    <div className='hospital-details3 '>
      <div className='container-75 col-lg-11'>
        <h3 className='text-center'>Unlock a Healthier Future: KlinicQ Benefits Everyone</h3>
        <p className='text-center'>
        Experience the transformative power of streamlined healthcare. KlinicQ is designed to elevate the experience for patients, doctors, hospitals, and pharmacies, fostering a connected and efficient healthcare ecosystem.
        </p>
        <div className='row align-items-stretch justify-content-center'>
          {images.map((image, index) => (
            <div key={index} className='col-lg-4 col-md-6 col-sm-6 col-12 mb-5'>
              <div className='circle-container1'>
                <div className='circle1'>
                  <img
  src={image.srcSmall}
  srcSet={`
    ${image.srcSmall} 150w,
    ${image.src} 300w
  `}
  sizes="(hover: hover) 300px, 150px"
  className="circle-image1"
  alt={image.title}
  loading="lazy"
  decoding="async"
/>

                  <div className='content1'>
                    <h3>{image.title}</h3>
                    <p>{image.description}</p>
                    <a href={image.href} className='learn-more1'>
                      Read More →
                    </a>
                  </div>
                </div>
                <div className='image-title1'>{image.title}</div> 
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;

// import React, { useState } from 'react';

// const ImageCarousel = () => {
//   const benefits = [
//     {
//       id: 1,
//       title: "Benefits of Patient",
//       description: "The patient portal is designed to manage primary & family members under the same account with a unique ID for each member.",
//       src: require("../../src/assets/images/website/doctor2.png"),
//       link: "https://example.com/patient-benefits"
//     },
//     {
//       id: 2,
//       title: "Benefits of Doctor",
//       description: "A doctor portal is designed based on the physician's specialty and can work for any specialization.",
//       src: require("../../src/assets/images/website/doctor5.png"),
//       link: "https://example.com/physician-benefits"
//     },
//     {
//       id: 3,
//       title: "Benefits of Hospital",
//       description: "A hospital portal is designed to manage multi-specialty and different consultation modes.",
//       src: require("../../src/assets/images/website/doctor4.png"),
//       link: "https://example.com/hospital-benefits"
//     },
//     {
//       id: 4,
//       title: "Benefits of Pharmacy",
//       description: "Pharmacy portals simplify medication management, allowing easy prescription refills and secure communication with pharmacists.",
//       src: require("../../src/assets/images/website/doctor6.png"),
//       link: "https://example.com/pharmacy-benefits"
//     },
//     {
//       id: 5,
//       title: "Benefits of Nurses",
//       description: "Nurse portals help manage patient care efficiently and support seamless communication among healthcare teams.",
//       src: require("../../src/assets/images/website/doctor3.png"),
//       link: "https://example.com/nurse-benefits"
//     },
//     {
//       id: 6,
//       title: "Benefits of Administration",
//       description: "Administration portals streamline administrative tasks, reduce paperwork, and improve overall hospital management.",
//       src: require("../../src/assets/images/website/doctor3.png"),
//       link: "https://example.com/administration-benefits"
//     }
//   ];

//   const [showBenefits, setShowBenefits] = useState(false);
//   const [hoveredBenefit, setHoveredBenefit] = useState(null);

//   return (
//     <div className='hospital-details3 py-5'>
//       <div className='container-75 col-lg-11'>
//         <h2 className='text-center'>Benefits</h2>
//         <p className='text-center header-description'>
//           Discover the wide-ranging benefits of using our platform. From patients to doctors, hospitals, pharmacies, nurses, and administration, everyone stands to gain from improved efficiency, better communication, and enhanced healthcare management.
//         </p>
//         {!showBenefits ? (
//           <div className='logo-container' onClick={() => setShowBenefits(true)}>
//             <div className='logo-text'>Benefits of Us</div>
//             <div className='click-me'>Click me</div>
//           </div>
//         ) : (
//           <div className='benefit-circles'>
//             {benefits.map((benefit) => (
//               <div
//                 key={benefit.id}
//                 className='benefit-circle'
//                 onMouseEnter={() => setHoveredBenefit(benefit.id)}
//                 onMouseLeave={() => setHoveredBenefit(null)}
//               >
//                 {hoveredBenefit !== benefit.id ? (
//                   <>
//                     <img src={benefit.src} className='benefit-image' alt={benefit.title} />
//                     <div className='benefit-title'>{benefit.title}</div>
//                   </>
//                 ) : (
//                   <div className='benefit-description'>
//                     <h3>{benefit.title}</h3>
//                     <p>{benefit.description}</p>
//                     <a href={benefit.link} className='learn-more'>
//                       Learn More →
//                     </a>
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ImageCarousel;






